(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockGesamtErgebnis', {
            bindings: {
                label: '@abgeLabel',
                zahlweise: '<abgeZahlweise',
                gesamtBetrag: '<abgeGesamtBetrag',
                options: '<abgeOptions'
            },
            transclude: {
                tooltip: '?tooltip'
            },
            templateUrl: 'bloecke/ergebnis/blockGesamtErgebnis.html',
            controller: BlockGesamtErgebnisController,
            controllerAs: 'blockGesamtErgebnisVm'
        });

    BlockGesamtErgebnisController.$inject = [
        'lodash',
        'AppConfig'
    ];
    function BlockGesamtErgebnisController(_, AppConfig) {
        var vm = this,
            zahlweiseTextMap;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        function activate() {
            vm.options = vm.options || {};
            zahlweiseTextMap = AppConfig.ANGEBOT.zahlweiseText;

            vm.gridLayoutCss = vm.options.grid || {};
            vm.gesamtLabel = (vm.label || 'Gesamtbeitrag');
            vm.options.currency = vm.options.currency || 'symbol';

            vm.zahlweiseText = zahlweiseTextMap[_.get(vm.zahlweise, 'wert')];

            if (!vm.gridLayoutCss.columnLeft) {
                vm.gridLayoutCss.columnLeft = 'small-6';
            }

            if (!vm.gridLayoutCss.columnRight) {
                vm.gridLayoutCss.columnRight = 'small-6';
            }
        }

        function onInit() {
            activate();
        }

        function onChanges() {
            activate();
        }

    }
})();
